/*
 * roles.js — Roles y permisos en la pantalla (C-016, ver diseno/CAMBIOS.md).
 * El servidor revisa lo mismo en cada ruta (backend/roles.js); aquí solo se decide qué se muestra.
 *
 * `admin` es el rol anterior: mientras un usuario lo tenga conserva todo lo que podía hacer.
 */

export const NOMBRES_ROL = {
  dueno: 'Dueño',
  supervisor: 'Supervisor',
  cobranza: 'Cobranza',
  contador: 'Contador',
  admin: 'Administrador (anterior)',
};

// Roles que se pueden asignar desde Ajustes → Usuarios.
export const ROLES_ASIGNABLES = ['contador', 'supervisor', 'cobranza', 'dueno'];

const tiene = (lista) => (usuario) => !!usuario && lista.includes(usuario.rol);

export const esAdministrador = tiene(['admin', 'dueno', 'supervisor']);
export const veClientes = tiene(['admin', 'dueno', 'supervisor', 'contador']);
export const veCobranza = tiene(['admin', 'dueno', 'supervisor', 'cobranza']);
export const veViento = tiene(['admin', 'dueno', 'cobranza']);
export const marcaRevisado = tiene(['admin', 'supervisor']);
// Solo el Dueño (o el `admin` de transición) asigna el rol Dueño y edita a un Dueño.
const asignaDueno = tiene(['admin', 'dueno']);

/** ¿Puede `usuario` crear, editar, desactivar o borrar a alguien con el rol `rolObjetivo`? */
export const puedeGestionarRol = (usuario, rolObjetivo) =>
  esAdministrador(usuario) && (!['admin', 'dueno'].includes(rolObjetivo) || asignaDueno(usuario));

export const nombreRol = (rol) => NOMBRES_ROL[rol] || rol || '';

/** Secciones de la barra azul que puede ver el usuario, en orden. */
export const seccionesDe = (usuario) => [
  veClientes(usuario) && { ruta: '/', nombre: 'Clientes' },
  veCobranza(usuario) && { ruta: '/cobranza', nombre: 'Cobranza' },
  veViento(usuario) && { ruta: '/viento', nombre: 'Viento' },
].filter(Boolean);
